import {Button} from '@chekinapp/ui';
import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {useFormContext} from 'react-hook-form';
import {AlertSizes, AlertTypes, ModalTwoButtonsWrapper} from '@guestapp/old-ui-kit';
import {VERIFICATION_METHODS, VerificationMethod} from '@chekin/api';
import {FormTypes} from '../../types';
import {Form, StyledAlertBox, InputContainer} from './styled';

type Props = {
  type: VerificationMethod;
  isLoading?: boolean;
  onSubmit: (data: FormTypes) => Promise<void>;
  children: ReactNode;
};

const ContactsForm = ({isLoading = false, type, onSubmit, children}: Props) => {
  const {t} = useTranslation();
  const {
    handleSubmit,
    formState: {isValid},
  } = useFormContext();

  const getInfoAlertMessage = () => {
    return t('contacts_verification_message', {
      type:
        type === VERIFICATION_METHODS.email ? t('email').toLocaleLowerCase() : t('sms'),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InputContainer>{children}</InputContainer>

      <StyledAlertBox
        text={getInfoAlertMessage()}
        type={AlertTypes.INFO}
        size={AlertSizes.S}
      />

      <ModalTwoButtonsWrapper className="contacts-verification__buttons">
        <Button type="submit" disabled={!isValid || isLoading} loading={isLoading}>
          {t('send_verification_code')}
        </Button>
      </ModalTwoButtonsWrapper>
    </Form>
  );
};

export {ContactsForm};
